import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-pagination-container',
  templateUrl: './pagination-container.component.html',
  styleUrls: ['./pagination-container.component.scss'],
  standalone: true,
  imports: [NgClass, LoaderComponent, TranslateModule],
})
export class PaginationContainerComponent {
  @Input() isFull: boolean;
  @Input() isLoading: boolean;
  @Input() isPlaylist: boolean;
  @Input() useLoader: boolean = true;

  @Output() displayMore: EventEmitter<void>;

  constructor() {
    this.isFull = false;
    this.isLoading = false;
    this.isPlaylist = false;
    this.displayMore = new EventEmitter<void>();
  }

  onDisplayMore(): void {
    this.displayMore.emit();
  }
}
